import React, { useEffect, useState } from "react";
import {
  documentDownloaded,
  downloadDocument,
  getDownloadedDocumentData,
} from "../store/documents";
import { useDispatch, useSelector } from "react-redux";
import { getAlert } from "../../Services/appAlerts";

const useDocDownload = () => {
  const [doc, setDoc] = useState(null);
  const downloadedDocumentDataSelector = useSelector(getDownloadedDocumentData);

  const dispatch = useDispatch();
  const handleDownloadFile = async (item) => {
    if (item.docId) dispatch(downloadDocument(item.docId));
    else dispatch(downloadDocument(item.id));

    setDoc(item);
  };

  useEffect(() => {
    console.log(
      "downloadedDocumentDataSelector",
      downloadedDocumentDataSelector,
    );
    if (downloadedDocumentDataSelector?.uploadUrl && doc) {
      try {
        //const url = window.URL.createObjectURL(downloadedDocumentDataSelector);
        window.open(downloadedDocumentDataSelector.uploadUrl, "_blank");
        dispatch(documentDownloaded(null));
      } catch (error) {
        getAlert("", error?.message, "error");
      }
    }
  }, [downloadedDocumentDataSelector]);

  return [handleDownloadFile];
};

export default useDocDownload;
